import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandLogo } from "@/components/Logo";

function LegalShell({ title, children }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2"><BrandLogo /></Link>
          <Link to="/" className="text-sm text-slate-500 flex items-center gap-1 hover:text-primary" data-testid="legal-home-link"><ArrowLeft className="w-4 h-4" /> Home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl font-bold text-slate-900">{title}</h1>
        <div className="mt-6 space-y-4 text-slate-600 leading-relaxed text-sm">{children}</div>
      </main>
    </div>
  );
}

export default function Terms() {
  return (
    <LegalShell title="Terms & Conditions">
      <p>By using Pack Mate you agree to these terms. Pack Mate is a marketplace that connects people who want to send packages with travellers who can carry them.</p>
      <h3 className="font-semibold text-slate-800 text-base">Your responsibilities</h3>
      <p>You are responsible for the accuracy of the information you provide and for complying with all applicable laws. You must never send or carry prohibited or illegal items.</p>
      <h3 className="font-semibold text-slate-800 text-base">Prohibited items</h3>
      <p>Drugs, weapons, cash, hazardous materials, counterfeit goods, and any illegal items are strictly forbidden. Violations may result in removal from the platform.</p>
      <h3 className="font-semibold text-slate-800 text-base">No guarantees</h3>
      <p>Pack Mate facilitates connections but does not guarantee the conduct of users or the outcome of any exchange. Use your own judgement and follow our safety guidance.</p>
      <h3 className="font-semibold text-slate-800 text-base">Account termination</h3>
      <p>You may delete your account at any time. We may suspend accounts that violate these terms.</p>
    </LegalShell>
  );
}
